var map = {
	"./about-symbols-01.svg": 25,
	"./about-symbols-02.svg": 26,
	"./about-symbols-03.svg": 27,
	"./about-symbols-04.svg": 28,
	"./about-symbols-05.svg": 29,
	"./about-symbols-06.svg": 30,
	"./about-symbols-07.svg": 31,
	"./about-symbols-08.svg": 32,
	"./about-symbols-09.svg": 33,
	"./about-symbols-10.svg": 34,
	"./accessability-guide.svg": 35,
	"./accessability-symbols.svg": 36,
	"./accessable-logo.svg": 37,
	"./app_store.svg": 38,
	"./as-accessible-accommodation.svg": 39,
	"./as-accessible-changing-room.svg": 40,
	"./as-accessible-fitting-room.svg": 41,
	"./as-accessible-toilet.svg": 42,
	"./as-ambulant-toilet.svg": 43,
	"./as-blue-badge-parking.svg": 44,
	"./as-braille.svg": 45,
	"./as-facilities-for-assistance-dogs.svg": 46,
	"./as-hearing-assistant.svg": 47,
	"./as-large-print.svg": 48,
	"./as-off-site-parking.svg": 49,
	"./as-on-site-parking.svg": 50,
	"./as-seat-available.svg": 51,
	"./as-sign-language.svg": 52,
	"./check.svg": 53,
	"./chevron-left-blue.svg": 54,
	"./chevron-left.svg": 55,
	"./chevron-right-blue.svg": 56,
	"./chevron-right.svg": 57,
	"./close.svg": 58,
	"./email.svg": 59,
	"./envelope.svg": 60,
	"./facebook-icon.svg": 61,
	"./facebook.svg": 62,
	"./favourite.svg": 63,
	"./help-bubble-down.svg": 64,
	"./help-bubble.svg": 65,
	"./instagram.svg": 66,
	"./link-arrow.svg": 67,
	"./linkedin.svg": 68,
	"./location.svg": 69,
	"./log-out.svg": 70,
	"./logo-small-blue.svg": 71,
	"./logo-small-purple.svg": 72,
	"./logo-small.svg": 73,
	"./mailinglist.svg": 74,
	"./media_tab_map.svg": 75,
	"./media_tab_photos.svg": 76,
	"./menu.svg": 77,
	"./new-window.svg": 78,
	"./placeholder.svg": 79,
	"./play_store.svg": 80,
	"./print-green.svg": 81,
	"./print.svg": 82,
	"./report-green.svg": 83,
	"./route-guide.svg": 84,
	"./save-green.svg": 85,
	"./save-guide.svg": 86,
	"./search.svg": 87,
	"./telephone.svg": 88,
	"./trash.svg": 89,
	"./twitter-icon.svg": 90,
	"./twitter.svg": 91,
	"./user.svg": 92,
	"./virtual-access-guide.svg": 93,
	"./youtube.svg": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24;